<template>
  <v-sheet class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 as-box-title as-bg-color-100" elevation="4" height="150"
    rounded max-width="600" width="100%" mb="6">
    <div>
      <div class="text-h5 font-weight-medium pa-2">
        DIRECCIÓN GENERAL LOGÍSTICA<br>UNIDAD DE MATERIAL BÉLICO
      </div>
      <p class="text-body-2 mb-4">
        Registro clasificado de armas de fuego, municiones y explosivos de uso Militar
      </p>
    </div>
  </v-sheet>


  <v-row>



    <v-col cols="4">
    <v-dialog v-model="dialog" max-width="900px" ref="certDialog">
      <template v-slot:activator="{ on }">
        <v-img
          src="@/assets/cert.png"
          alt="Imagen"
          class="img"
          height="500px"
          v-on="on"
          @click="dialog = true"
        ></v-img>
      </template>
<div id="content-to-print">
  <v-card>
        <v-card-title class="cert-title titulo">CERTIFICADO DE REPOSICIÓN Nº 01/2023</v-card-title>
        <v-card-text class="cert-content">
          <p>La <b>Unidad de Material Bélico del Ministerio de Defensa</b>, en atención a la solicitud presentada por el Interesado:</p>
          <p><b>CERTIFICA:</b></p>
          <p>que, al Señor:</p>
          <p class="centered-text"><b>My.DIM. Sotomayor Frlores Edwin</b> con C.I.: <b>51849522</b></p><br/>
          <p>Se presentó en la Unidad de Material Bélico dependiente de la Dirección General de Logística del Ministerio de Defensa a objeto de realizar la presentación de su Arma de Fuego, adquirida de la casa matriz de la “FABRICA BOLIVIANA DE MUNICIONES” por concepto de <b>REPOSICIÓN</b>, para su posterior inserción en el Sistema Informático, en reemplazo de su pistola extraviada, con las siguientes características:</p>

          <v-data-table
    :headers="headers"
    :items="data"
    :items-per-page="10"
    class="elevation-1"
  ></v-data-table>
      <p>Advertencias.- </p>
      <p>-	El presente Certificado es válido solo para trámites administrativos dentro las FF.AA.</p>
      <p>-	El presente Certificado es válido solo para trámites administrativos dentro las FF.AA.</p>
      <p>-	Cualquier alteración, borrón, raspadura o enmienda, anula el presente Certificado.</p>
      <br/>
      <p class="right-align">La Paz {{ currentDate }}</p>

      <div class="grid-container mb-5">
        <div class="centered-text grid-item">Lic. Ubaldo Rojas Cuchallo<br/><b>RESP. DE LA UNIDAD DE MAT. BEL.</b>
        </div>

        <div class="centered-text grid-item">Cnl. DAEN. Marcelo Vargas Barral<br/><b>DIRECTOR GENERAL DE LOGISTICA</b>
        </div>
      </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="printContent">Imprimir</v-btn>
          <v-btn color="secondary" @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
</div>
    </v-dialog>
  </v-col>




    <v-col cols="4">
      <v-img
        src="@/assets/r_cargador.png"
        alt="Imagen"
        class="img"
        height="500px"
      ></v-img>
    </v-col>
    <v-col cols="4">
      <v-img
        src="@/assets/r_cuchillo.png"
        alt="Imagen"
        class="img"
        height="500px"
      ></v-img>
    </v-col>
    <v-col cols="4">
      <v-img
        src="@/assets/r_pistola.png"
        alt="Imagen"
        class="img"
        height="500px"
      ></v-img>
    </v-col>
    <v-col cols="4">
      <v-img
        src="@/assets/r_sable.png"
        alt="Imagen"
        class="img"
        height="500px"
      ></v-img>
    </v-col>

  </v-row>

</template>



<script>

export default {

  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Columna 1', value: 'column1' },
        { text: 'Columna 2', value: 'column2' },
        { text: 'Columna 3', value: 'column3' },
        { text: 'Columna 4', value: 'column4' }
      ],
      data: [
        { column1: 'Valor 1', column2: 'Valor 2', column3: 'Valor 3', column4: 'Valor 4' },
        { column1: 'Valor 5', column2: 'Valor 6', column3: 'Valor 7', column4: 'Valor 8' },
        // Agrega más filas de datos según sea necesario
      ]
    };
  },
  computed: {
    currentDate() {
      const date = new Date();
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString('es-ES', options);
    }
  },


  methods: {
    printContent() {
      const printWindow = window.open('', '_blank');
      const contentToPrint = document.getElementById('content-to-print').innerHTML;
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Imprimir</title>
            <style>
              .titulo{
              align-content: center;
              }
              @media print {
                /* Ajusta los estilos de impresión según tus necesidades */
              }
            </style>
          </head>
          <body>
            ${contentToPrint}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  }


};




</script>

<style scoped>
.elevation-1 {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.cert-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  font-family: "Times New Roman", Times, serif;
}

.cert-content {
  text-align: justify;
  font-family: "Times New Roman", Times, serif;
  font-size: 16px;
  line-height: 1.5;
}
.centered-text {
  text-align: center;
}
.right-align {
  text-align: right;
}
.grid-container {
  font-family: "Times New Roman", Times, serif;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  margin-top: 150px;
}

.grid-item {
  padding: 20px;
}
.hide-on-print {
    display: none;
  }

  @media print {
  @page {
    size: letter;
    margin: 0;
  }
}
</style>